// Setzt die CSS-Klasse `.is-scrolled` auf #wrapper-navbar, sobald der Nutzer
// ueber einen kleinen Schwellwert hinaus scrollt. Die eigentliche Optik
// (Hintergrund, Transition) liegt im Stylesheet.

(function () {
    'use strict';

    const THRESHOLD = 10;
    const CLASS_NAME = 'is-scrolled';

    const navbar = document.getElementById('wrapper-navbar');
    if (!navbar) {
        return;
    }

    let isScrolled = false;

    const update = () => {
        const shouldBeScrolled = window.scrollY > THRESHOLD;
        if (shouldBeScrolled === isScrolled) {
            return;
        }
        isScrolled = shouldBeScrolled;
        navbar.classList.toggle(CLASS_NAME, isScrolled);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
})();